import { FunctionComponent, ReactNode } from "react";
import { AuthenticationResult, EventMessage, EventType, PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";

import { msalConfig } from "../auth-config";

interface IAuthProviderProps {
  children: ReactNode;
}

const AuthProvider: FunctionComponent<IAuthProviderProps> = ({ children }: IAuthProviderProps) => {
  const newMsalInstance = new PublicClientApplication(msalConfig);

  const accounts = newMsalInstance.getAllAccounts();
  if (accounts.length > 0 && !newMsalInstance.getActiveAccount()) {
    newMsalInstance.setActiveAccount(accounts[0]);
  }

  // Listen for sign-in event and set active account
  newMsalInstance.addEventCallback((event: EventMessage) => {
    const authenticationResult = event.payload as AuthenticationResult;
    const account = authenticationResult?.account;
    if (event.eventType === EventType.LOGIN_SUCCESS && account) {
      newMsalInstance.setActiveAccount(account);
    }
  });

  if (!newMsalInstance) {
    return null;
  }

  return <MsalProvider instance={newMsalInstance}>{children}</MsalProvider>;
};

export const useAuthProvider = () => {
  return { AuthProvider };
};
